import { Injectable, Inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { CORE_CONFIGURATION } from '../configuration';
import { SessionStateModel, SessionState } from '../session';
import { ApiModule } from './api.module';
import { BaseApiService } from './base-api.service';
import { Observable } from 'rxjs';
import { SimNumbers } from 'src/app/change/shared/state/sim-change.action';
import { buildAwsApi } from '../util.class';

@Injectable({
  providedIn: ApiModule,
  deps: [BaseApiService],
})
/* eslint-disable */
export class NumbersApiService {
    keyMapAWS: any;

    constructor(
        private http: BaseApiService,
        @Inject(CORE_CONFIGURATION) private config,
        private _store: Store) {
        const { keyMapAWS }: SessionStateModel = this._store.selectSnapshot(SessionState);
        this.keyMapAWS = keyMapAWS;
    }

     listNumbers({ params }:SimNumbers): Observable<any>{
        const apiAWS = buildAwsApi(this.keyMapAWS,'company_assets', {delegationCustCode:params.delegationCustcode,category:params.category});
    
        return this.http.get({
          hideError: false,
          apiBasePath:  this.config.apiBasePath,
          path: apiAWS,
          awsApi: apiAWS !== null,
          
        });
    }
    listPaginationNumbers({ params }:SimNumbers): Observable<any>{
        const apiAWS = buildAwsApi(this.keyMapAWS,'company_assets_with_page', {delegationCustCode:params.delegationCustcode,category:params.category,offset:params.offset,limit:params.limit});
    
        return this.http.get({
          hideError: false,
          apiBasePath:  this.config.apiBasePath,
          path: apiAWS,
          awsApi: apiAWS !== null,
          
        });
    }
    

    searchNumbers({ params }:SimNumbers): Observable<any>{
        const apiAWS = buildAwsApi(this.keyMapAWS,'company_assets_search', {delegationCustCode:params.delegationCustcode,partialNumber:params.partialNumber});
    
        return this.http.get({
          hideError: false,
          apiBasePath:  this.config.apiBasePath,
          path: apiAWS,
          awsApi: apiAWS !== null,
          
        });
      }
}